import { filterObject } from '../01-core/Utilities';
import { OptionalLink } from '../01-core/OptionalLink';
import { Media, MediaProps } from '../02-atoms/Media';

export interface AvatarProps {
  /** Name */
  name: string;
  /** Description on tag */
  description?: string;
  /** Title on tag */
  title?: string;
  /** Optional image */
  image?: MediaProps;
  /** Optional link avatar */
  href?: string;
  /** Optional link target */
  target?: HTMLAnchorElement['target'];
  /** Additional class */
  className?: string;
  /** Optional click handler */
  onClick?: () => void;
}

/** An avatar */
export const Avatar = ({
  name,
  title,
  description,
  image,
  href,
  target,
  className,
  ...props
}: AvatarProps) => {
  return (
    <div className={['avatar', className].join(' ')} title={title} {...props}>
      <OptionalLink href={href} target={target}>
        {image && (
          <Media
            aspect="square"
            className={'avatar__image ' + image?.className}
            alt={`Portrait ${name}`}
            {...filterObject(image, [], ['aspect', 'className'])}
          />
        )}
        <div className="avatar__content">
          <strong>{name}</strong>
          {description && <span>{description}</span>}
        </div>
      </OptionalLink>
    </div>
  );
};
